import { useState } from 'react';
import { useSelector } from 'react-redux';
import Accordion from 'react-bootstrap/Accordion';

import { State } from 'redux/initialState';
import useUserValidation from 'hooks/useUserValidation';

import MainAdministratedMenu from './Menus/MainAdministratedMenu';
import MainParticipatedMenu from './Menus/MainParticipatedMenu';
import MainBeneficiatedMenu from './Menus/MainBeneficiatedMenu';

const MainMenu = () => {
  const { user } = useSelector((state: State) => state);

  const userValidations = useUserValidation(user);

  const [activeKey, setActiveKey] = useState<string | undefined>(undefined);

  const handleAccordionChange = (eventKey: string | null) => {
    setActiveKey(eventKey || undefined);
  };

  return (
    <Accordion
      id="main-menu__collapsed"
      className="bg-transparent"
      activeKey={activeKey}
      onSelect={handleAccordionChange}
    >
      {userValidations.hasAdministrated && (
        <MainAdministratedMenu order="0" isActive={activeKey === '0'} />
      )}

      {userValidations.hasParticipated && (
        <MainParticipatedMenu order="1" isActive={activeKey === '1'} />
      )}

      {userValidations.hasBeneficiated && (
        <MainBeneficiatedMenu order="2" isActive={activeKey === '2'} />
      )}
    </Accordion>
  );
};

export default MainMenu;
